module.exports = __webpack_public_path__ + "static/img/wrp975.4e4ab12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wrp975.jpg
// module id = IpJr
// module chunks = 0